export function attachScript(src, tryRequireJs) {
  if (tryRequireJs === void 0) {
    tryRequireJs = false;
  }
  if (tryRequireJs) {
    const win = window;
    if (win.define && win.define.amd) {
      const viewerWindow = win;
      return new Promise(resolve => {
        // viewer require-js found
        viewerWindow.require([src], resolve);
      });
    }
  }
  return new Promise(resolve => {
    const {
      body
    } = document;
    const script = document.createElement('script');
    script.src = src;
    let done = false;

    // Attach handlers for all browsers
    script.onload = script.onreadystatechange = function () {
      if (!done && (!this.readyState || this.readyState === 'loaded' || this.readyState === 'complete')) {
        done = true;
        resolve();
        script.onload = script.onreadystatechange = null;
        if (body && script.parentNode) {
          body.removeChild(script);
        }
      }
    };
    body.appendChild(script);
  });
}
//# sourceMappingURL=attach-script.js.map